import { doesToolSupportPromptInstruction, isMultiPromptTool } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomerPersonaStore } from 'src/store';

import { LocalStore } from '../../store';

const useCustomerPersonaState = createStateSelectorHook(CustomerPersonaStore, [
  'loadingSuggestedCustomerPersonas',
]);

const useLocalState = createStateSelectorHook(LocalStore, [
  'generationTool',
  'isExtractingBrief',
  'currentUrls',
]);

export const useDisplayLoadingFromURL = () => {
  const { loadingSuggestedCustomerPersonas } = useCustomerPersonaState();
  const { generationTool, isExtractingBrief, currentUrls } = useLocalState();

  if (!doesToolSupportPromptInstruction(generationTool) && !isMultiPromptTool(generationTool)) {
    return false;
  }

  return currentUrls?.length > 0 && (isExtractingBrief || loadingSuggestedCustomerPersonas);
};
